import { ajaxGet, ajaxPost, ajaxPostBytes, ajaxDelete } from './AjaxHelper.js';

export function checkAuthentication(callback) {
    ajaxGet("/api/useractions", (data, ok) => {
        callback(ok);
    })
}

export function postJob(jobId, mediumId, mediumOrgId, callback) {
    var data = {
        jobId: jobId,
        mediumId: mediumId,
        mediumOrgId: mediumOrgId
    }

    ajaxPost("/api/useractions/job", data, (newData, ok) => {
        callback(ok);
    });
}

export function getPersonalia(languageId, jobId, callback) {
    ajaxGet("/api/useractions/personalia?seqlang=" + languageId + "&jobId=" + jobId, (data, ok) => {
        if (!ok) {
            callback(null);
            return;
        }

        var bDay = "00".substring(0, 2 - data.bDay.length) + data.bDay;
        var bMon = "00".substring(0, 2 - data.bMon.length) + data.bMon;
        var bYear = "0000".substring(0, 4 - data.bYear.length) + data.bYear;

        if (languageId === 3) {
            data["birthday"] = bMon + "/" + bDay + "/" + bYear;
        } else {
            data["birthday"] = bDay + "/" + bMon + "/" + bYear;
        }

        callback(data);
    });
}

export function getNewPersonalia(callback) {
    ajaxGet("/api/useractions/newpersonalia", (data, ok) => {
        callback(ok ? data: null);
    });
}

export function postPersonalia(data, jobId, languageId, callback) {
    var birthdayValues = data.birthday.split("/");
    var bDay = (languageId === 3) ? birthdayValues[1] : birthdayValues[0];
    var bMon = (languageId === 3) ? birthdayValues[0] : birthdayValues[1];
    var bYear = birthdayValues[2];

    data.bDay = bDay;
    data.bMon = bMon;
    data.bYear = bYear;
    data.strSiteNam = data.mail;

    data.seqjob = jobId;
    data.seqlang = languageId;

    ajaxPost("/api/useractions/personalia", data, (newData, ok) => {
        callback(newData, ok);
    });
}

export function  getQuestions(jobId, languageId, callback) {
    ajaxGet("/api/useractions/questions?seqjob=" + jobId + "&seqlang=" + languageId, (data, ok) => {
        callback(ok ? data : null);
    });
}

export const postQuestion = (x, seqjob, seqquest, answer) => {
    var data = {
        seqJob: seqjob,
        seqQuest: seqquest,
        answer: answer
    };

    ajaxPost("/api/useractions/question", data, (newData, ok) => {});
}

export function getFunctions(languageId, callback) {
    ajaxGet("/api/useractions/functions/objective?seqlang=" + languageId, (data, ok) => {
        callback(ok ? data : null);
    });
}

export function postFunction(id, functionId, synonymId, functionText, callback) {
    var data = {
        Id: id,
        FunctionId: (functionId == null) ? 0 : functionId,
        SynonymId: synonymId,
        FunctionText: functionText
    }

    ajaxPost("/api/useractions/functions/objective", data, (newData, ok) => {
        callback(ok ? newData : null);
    });
}

export function deleteFunction(id, callback) {
    var data = {
        Id: id,
        FunctionId:  0,
        FunctionText: null
    }

    ajaxPost("/api/useractions/functions/objective", data, (newData, ok) => {
        if (newData == null) {
            callback();
        }      
    });
}

export function getSectors(languageId, callback) {
    ajaxGet("/api/useractions/sectors/objective?seqlang=" + languageId, (data, ok) => {
        callback(ok ? data : null);
    });
}

export function postSector(id, sectorId, synonymId, sectorText, callback) {
    var data = {
        Id: id,
        SectorId: (sectorId == null) ? 0 : sectorId,
        SynonymId: synonymId,
        SectorText: sectorText
    }

    ajaxPost("/api/useractions/sectors/objective", data, (newData, ok) => {
        callback(ok ? newData : null);
    });    
}

export function deleteSector(id, callback) {
    var data = {
        Id: id,
        SectorId:  0,
        SectorText: null
    }

    ajaxPost("/api/useractions/sectors/objective", data, (newData, ok) => {
        if (newData == null) {
            callback();
        }      
    });
}

export function getPersonRegions(languageId, callback) {
    ajaxGet("/api/useractions/personregions?languageId=" + languageId, (data, ok) => {
        callback(ok ? data : null);
    });
}

export function deletePersonRegions(personRegionId, callback) {
    ajaxDelete("/api/useractions/personregions?personRegionId=" + personRegionId, (newData, ok) => {
        if (ok) {
            callback();
        }
    });
}

export function postPersonRegions(regionId, regionText, callback) { 
    var data = {
        regionId: regionId,
        regionText: regionText
    }

    ajaxPost("/api/useractions/personregions", data, (newData, ok) => {
        callback(ok ? newData : null);
    }); 
}

export function getJobSkills(jobId, languageId, callback) {
    ajaxGet("/api/useractions/jobskills?seqjob=" + jobId + "&seqlang=" + languageId, (data, ok) => {
        callback(ok ? data : null);
    });
}

export function postJobSkills(id, skillId, synonymId, skillText, score, jobId, callback) {
    var data = {
        id: id,
        skillId: (skillId == null) ? 0: skillId,        
        synonymId: synonymId,
        skillText: skillText,
        score: score,
        jobId: jobId
    }

    ajaxPost("/api/useractions/jobskills", data, (newData, ok) => {
        callback(ok ? newData : null);
    });
}

export function deleteJobSkills(seqskill, skill, callback) {
    ajaxDelete("/api/useractions/jobskills?seqskill=" + seqskill + "&skill=" + skill, (newData, ok) => {
        if (ok) {
            callback();
        }
    });
}

export function getJobCompetences(jobId, languageId, callback) {
    ajaxGet("/api/useractions/jobcompetences?seqjob=" + jobId + "&seqlang=" + languageId, (data, ok) => {
        callback(ok ? data : null);
    });
}

export function postJobCompetences(seqjob, id, name, score, seqPersComp, callback) {    
    var data = {
        id: id,
        name: name,
        score: score,
        seqJob: seqjob,
        seqPersComp: seqPersComp
    }

    ajaxPost("/api/useractions/jobcompetences", data, (newData, ok) => {
        callback(ok ? newData : null);
    });
}

export function getJobLanguages(jobId, languageId, callback) {
    ajaxGet("/api/useractions/joblanguages?seqjob=" + jobId + "&seqlang=" + languageId, (data, ok) => {
        callback(ok ? data : null);
    });
}

export function postJobLanguages(seqjob, seqlang, name, candelete, talk, read, write, seqPersLang, callback) {
    var data = {
        id: seqlang,
        name: name,
        candelete: candelete,
        talk: talk,
        read: read,
        write: write,
        seqJob: seqjob,
        seqPersLang: seqPersLang
    }

    ajaxPost("/api/useractions/joblanguages", data, (newData, ok) => {
        callback(ok ? newData : null);
    });
}

export function deleteJobLanguages(seqlang, callback) {
    ajaxDelete("/api/useractions/joblanguages?seqlang=" + seqlang, (newData, ok) => {
        if (ok) {
            callback();
        }
    });
}

export function getPersonWorkExperiences(languageId, callback) {
    ajaxGet("/api/useractions/personworkexperiences?seqlang=" + languageId, (data, ok) => {
        callback(ok ? data : null);
    });
}

export function postPersonWorkExperiences(id, seqOrg, orgText, datStart, datLeave, 
    functionId, functionSynonymId, functionText, 
    sectorId, sectorSynonymId, sectorText, 
    countryId, description, callback) {
        
    var data = {
        id: id,
        seqOrg: seqOrg,
        org: orgText,
        datStart: datStart,
        datLeave: datLeave,
        functionId: (functionId === 0) ? null : functionId,
        functionSynonymId: functionSynonymId,
        function: functionText,
        sectorId: (sectorId === 0) ? null : sectorId,
        sectorSynonymId: sectorSynonymId,
        sector: sectorText,
        countryId: countryId,
        description: description
    }

    ajaxPost("/api/useractions/personworkexperiences", data, (newData, ok) => {
        callback(ok ? newData : null);
    });
}

export function deletePersonWorkExperiences(seqpersorg, callback) {
    ajaxDelete("/api/useractions/personworkexperiences?seqpersorg=" + seqpersorg, (newData, ok) => {
        if (ok) {
            callback();
        }
    });
}

export function getPersonEducations(languageId, callback) {
    ajaxGet("/api/useractions/personeducations?seqlang=" + languageId, (data, ok) => {
        callback(ok ? data : null);
    });
}

export function postPersonEducations(id, seqOrg, orgText, countryId, yearGrad, resultId, isHighest, description, eduDomainId, eduNiveauId, eduDescriptionId, eduDesciptionSynonymId, callback) {
    var data = {
        id: id,
        seqOrg: seqOrg,
        org: orgText,
        countryId: countryId,
        yearGrad: yearGrad,
        resultId: resultId,
        isHighest: isHighest,
        description: description,
        eduDomainId: eduDomainId,
        eduNiveauId: eduNiveauId,
        eduDescriptionId: eduDescriptionId,
        eduDescriptionSynonymId: eduDesciptionSynonymId
    }

    ajaxPost("/api/useractions/personeducations", data, (newData, ok) => {
        callback(ok ? newData : null);
    });
}

export function deletePersonEducations(seqpersedu, callback) {
    ajaxDelete("/api/useractions/personeducations?seqpersedu=" + seqpersedu, (newData, ok) => {
        if (ok) {
            callback();
        }
    });
}

export function getPersonSalary(callback) {
    ajaxGet("/api/useractions/personsalary", (data, ok) => {
        callback(ok ? data : null);
    });
}

export function postPersonSalary(currentSalary, currentSalaryPeriod, currentExtra, preferredSalary, preferredSalaryPeriod, preferredExtra, callback) {
    var data = {
        currentSalary: currentSalary,
        currentSalaryPeriod: currentSalaryPeriod,
        currentExtra: currentExtra,
        preferredSalary: preferredSalary,
        preferredSalaryPeriod: preferredSalaryPeriod,
        preferredExtra: preferredExtra
    }

    ajaxPost("/api/useractions/personsalary", data, (newData, ok) => {
        callback(ok ? newData : null);
    });
}

export function getPersonDeontologies(callback) {
    ajaxGet("/api/useractions/persondeontologies", (data, ok) => {
        callback(ok ? data : null);
    });
}

export function postPersonDeontologies(vacature, carriereInfo, news, cvOnline, callback) {
    var data = {
        vacature: vacature,
        carriereInfo: carriereInfo,
        news: news,
        cvOnline: cvOnline
    }

    ajaxPost("/api/useractions/persondeontologies", data, (newData, ok) => {
        callback(ok ? data : null);
    });
}

export function getPersonAttachments(languageId, jobId, callback) {
    ajaxGet("/api/useractions/personattachments?seqlang=" + languageId + "&jobId=" + jobId, (data, ok) => {
        callback(ok ? data : null);
    });
}

export function postPersonAttachments(file, seqtemp, jobId, languageId, callback) {
    // file = input[type=file]
    var formData = new FormData();
    formData.append("file", file.files[0]);

    var route = "/api/useractions/personattachments?" 
        + "fileName=" + encodeURIComponent(file.files[0].name.split("\\").pop()) 
        + "&contentType=" + file.files[0].type 
        + "&seqtemp=" + seqtemp 
        + "&seqjob=" + jobId 
        + "&seqlang=" + languageId;

    ajaxPostBytes(route, formData, (newData, ok) => {
        callback(ok ? newData : null);
    });
}

export function deletePersonAttachments(sequpload, seqhis, callback) {
    var route = "/api/useractions/personattachments?"
        + "sequpload=" + sequpload
        + "&seqhis=" + seqhis;

    ajaxDelete(route, (newData, ok) => {
        if (ok) {
            callback();
        }
    });
}

export function postCompleteRegistrant(jobId, languageId, callback) {
    var data = {
        jobId: jobId,
        languageId: languageId
    }

    ajaxPost("/api/useractions/completeregistrant", data, (newData, ok) => {
        if (ok) {
            callback();
        }
    });
}

export function getApplications(languageId, callback) {
    ajaxGet("/api/useractions/applications?languageId=" + languageId, (data, ok) => {
        callback(ok ? data : null);
    });
}

export function postPassword(passwordCurrent, passwordNew, callback) {
    var data = {
        passwordCurrent: passwordCurrent,
        passwordNew: passwordNew
    }
    
    ajaxPost("/api/useractions/password", data, (newData, ok) => {
        callback(ok ? newData : false);
    });
}

export function getMails(callback) {
    ajaxGet("/api/useractions/mails", (data, ok) => {
        callback(ok ? data: null);
    });
}

export function postMail(messageId, callback) {
    var data = { messageId: messageId }

    ajaxPost("/api/useractions/mails", data, (newData, ok) => {
        callback(ok);
    });
}

export function deleteMail(historyId, callback) {
    ajaxDelete("/api/useractions/mails?historyId=" + historyId, (newData, ok) => {
        callback(ok);
    });
}

export function getHomepageInfo(callback) {
    ajaxGet("/api/useractions/homepageinfo", (data, ok) => {
        callback(ok ? data : null);
    });
}

export function postContact(subject, body, jobId, callback) {
    var data = {
        subject: subject,
        body: body,
        jobId: jobId
    }

    ajaxPost("/api/useractions/contact", data, (newData, ok) => {
        callback(ok ? newData: null);
    });
}

export function deleteDeactivateAccount(callback) {
    ajaxDelete("/api/useractions/deactivateaccount", (newData, ok) => {
        callback(ok);
    });
}


// WEBPACK FOOTER //
// ./src/Api/UserActions.js